import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  IconButton,
  Typography,
} from "@mui/material";
import { useState } from "react";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { Close, Send } from "@mui/icons-material";
import RichTextField from "../../../ui/components/Form/RichTextField";
import CustomTextField from "../../../ui/components/Form/TextField";
import { useSendEmail } from "../api/sendEmail";

const schema = yup.object().shape({
  subject: yup.string().required("Campo obrigatório"),
  message: yup.string().required("Campo obrigatório"),
});

export default function SendEmail({
  recipient,
  canChangeRecipient = false,
  canChangeSubject = true,
  onSuccess = () => {},
  defaultValues = {
    subject: "",
    message: "",
  },
}) {
  const formMethods = useForm({ resolver: yupResolver(schema), defaultValues });

  const sendEmailMutation = useSendEmail();

  const handleSubmitForm = (values) => {
    sendEmailMutation.mutate(
      {
        ...values,
        recipient,
      },
      {
        onSuccess,
      }
    );
  };

  return (
    <form onSubmit={formMethods.handleSubmit(handleSubmitForm)}>
      {canChangeSubject && (
        <CustomTextField
          sx={{ width: "100%" }}
          formMethods={formMethods}
          fieldName={"subject"}
          label="Assunto"
          variant="standard"
        />
      )}

      <RichTextField
        formMethods={formMethods}
        fieldName={"message"}
        label="Conteúdo da mensagem"
      />
      <Button type="submit">
        <Send />
      </Button>
    </form>
  );
}

export function SendEmailDialog({ children, ...rest }) {
  const [dialogOpen, setDialogOpen] = useState(false);
  const handleOpenDialog = () => {
    setDialogOpen(true);
  };
  const handleCloseDialog = () => {
    setDialogOpen(false);
  };
  const methods = {
    openDialog: handleOpenDialog,
    closeDialog: handleCloseDialog,
  };

  return (
    <>
      {children(methods)}
      <Dialog
        open={dialogOpen}
        onClose={handleCloseDialog}
        maxWidth={"sm"}
        fullWidth
      >
        <IconButton
          sx={{ position: "absolute", top: 3, right: 3 }}
          onClick={handleCloseDialog}
        >
          <Close />
        </IconButton>{" "}
        <SendEmail {...rest} />
      </Dialog>
    </>
  );
}
